import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AgreementType } from 'src/app/shared/enum';
import { PersonalInfoComponent } from '../personal-info/personal-info.component';
import { ContactNoComponent } from '../contact-no/contact-no.component';
import { SignupService } from '../../service/signup.service';
import { SurveyComponent } from '../survey/survey.component';
import { BehaviorSubject } from 'rxjs';
import { FeatureFlagService } from '@laasy/common-layout';


@Component({
  selector: 'app-idp-based-signup',
  templateUrl: './idp-based-signup.component.html',
  styleUrls: ['./idp-based-signup.component.scss']
})
export class IdpBasedSignupComponent implements OnInit, AfterViewInit {
  @Input() userProfile: any = {};
  @ViewChild('personalInfo') personalInfo!: PersonalInfoComponent;
  @ViewChild('contact') contact!: ContactNoComponent;
  @ViewChild(SurveyComponent) surveyComponent!: SurveyComponent;
  @ViewChild('subtenant') subTenantComponent!: ElementRef;

  termsAndConditions = AgreementType.TermsAgreement;
  privacyPolicy = AgreementType.PolicyAgreement;
  page: string = 'ssoSignUp';
  isLoggedIn: boolean = false;
  width = 'auto';
  FormNames = {
    subtenant: 'subtenant',
    userInfo: 'userinfo',
    survey: 'survey'
  }
  formSteps = [this.FormNames.userInfo]
  currentFormIndex = 0
  currentFormIndex$: BehaviorSubject<number> = new BehaviorSubject<number>(-1);

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly signUpService: SignupService,
    public featureFlagService: FeatureFlagService
  ) { }

  ngOnInit(): void {
    this.currentFormIndex$.next(0)
    this.route.queryParams.subscribe((queryParams) => {
      if (queryParams['isLoggedIn'])
        this.isLoggedIn = true
    });

    const isSubtenant = this.signUpService.isSubTenant()
    const isSurvey = this.signUpService.showSurvey()

    if(isSubtenant){
      this.formSteps.unshift(this.FormNames.subtenant)
      this.updatePadding(true)
    }

    if(isSurvey){
      this.formSteps.push(this.FormNames.survey)
    }

  }

  ngAfterViewInit(): void {
    this.currentFormIndex$.subscribe((i:number)=>{
      const removePadding = [this.FormNames.survey, this.FormNames.subtenant].includes(this.formSteps[i])
      this.updatePadding(removePadding)

      if([this.FormNames.subtenant].includes(this.formSteps[i])){
        // remove back button
        const backButton = this.subTenantComponent.nativeElement.querySelector('.container .circle')
        backButton?.remove()
      }

    })
  }

  @HostListener('window:surveyEvent', ['$event'])
  surveyEvent(event: CustomEvent): void {
    console.log(event)
    if(event.detail.calledFrom === 'back' &&  event.detail.index === 0){
      this.handleSurveyBack()
    }
    else if(event.detail.calledFrom === 'continue' && event.detail.surveyLength - 1 === event.detail.index){
      this.handleSubmit()
    }
  }

  updatePadding(isRemove: boolean): void {
    const leftcontainer = document.querySelector('.container .leftcontainer') as HTMLElement
    if (isRemove) {
      const content = leftcontainer.querySelector('.content') as HTMLElement
      content?.classList?.remove('content')
      content?.classList?.add('content-empty')
    } else {
      const content = leftcontainer.querySelector('.content-empty') as HTMLElement
      content?.classList?.remove('content-empty')
      content?.classList?.add('content')
    }
  }

  handleSurveyBack(): void {
    this.decrementFormIndex()
  }

  next(): void {
    if (!this.allFieldsValid()) return;
    if (this.currentFormIndex >= this.formSteps.length - 1) this.handleSubmit()
    this.incrementFormIndex()
  }

  handleSubmit() {
    sessionStorage.setItem('ssoSignupUserInfo', JSON.stringify(this.userProfile));
    if (this.isLoggedIn) {
      this.resetForms();
      this.router.navigate(['/auth/signupredirect'], { queryParams: { userFilledForm: true } });
    }
  }

  onTermsClick(agreementType: string): void {
    if (agreementType === this.privacyPolicy) window.open(window.location.origin + '/privacy')
    if (agreementType === this.termsAndConditions) window.open(window.location.origin + '/termsandconditions')
  }

  allFieldsValid() {
    if (!this.personalInfo && !this.contact) return false;
    const { userinfoAuthForm } = this.personalInfo;
    const { contactNoForm } = this.contact;
    const invalid = 'INVALID';
    return !(
      userinfoAuthForm.status === invalid ||
      contactNoForm.status === invalid
    ) && this.userProfile.termsAgreement;
  }

  resetForms() {
    const { userinfoAuthForm } = this.personalInfo;
    const { contactNoForm } = this.contact;
    userinfoAuthForm.reset();
    contactNoForm.reset();
    this.userProfile.termsAgreement = false
  }

  selectedSubtenant(subtenantId: string): void {
    this.userProfile.subtenant = subtenantId;
    this.incrementFormIndex()
  }

  incrementFormIndex(){
    this.currentFormIndex++
    this.currentFormIndex$.next(this.currentFormIndex)
  }

  decrementFormIndex(){
    this.currentFormIndex--
    this.currentFormIndex$.next(this.currentFormIndex)
  }

  displayHideForm(formType:string){
    return {'display': this.formSteps[this.currentFormIndex] === formType ? 'block' : 'none'}
  }
}

